/**
 * Prevent browsers from stepping a focused number input when the user scrolls.
 * Blurring preserves normal page scrolling and leaves keyboard controls intact.
 */
export function installNumberInputWheelGuard(documentRef: Document = document): () => void {
  const handleWheel = (event: WheelEvent) => {
    blurFocusedNumberInput(event.target, documentRef.activeElement);
  };

  documentRef.addEventListener('wheel', handleWheel, { capture: true, passive: true });

  return () => documentRef.removeEventListener('wheel', handleWheel, true);
}

export function blurFocusedNumberInput(
  target: EventTarget | null,
  activeElement: Element | null,
): void {
  if (target !== activeElement) return;

  const input = target as HTMLInputElement | null;
  if (input?.nodeName === 'INPUT' && input.type === 'number') {
    input.blur();
  }
}
